import { getRoute } from '@wellesley/router'
import useCopyToClipboard from 'hooks/useCopyToClipboard'
import { staticState } from '@wellesley/host-remote/common/staticState'

export const useCopyGroupUrl = (groupname: string) => {
  const { baseUrl: staticBaseUrl } = staticState.get()
  const baseUrl = staticBaseUrl || window.location.origin
  const groupRoute = getRoute('/g/:groupname', {
    groupname,
  })
  const textToCopy = `${baseUrl}${groupRoute}`

  const [copy] = useCopyToClipboard({
    textToCopy,
    toastMsg: 'Group URL is copied to clipboard',
  })

  return copy
}
